import template from './customize.html';
import { actions, selectors } from '../../../../state';
import { STATES, ITEM_STATUSES, ITEM_KINDS } from '../../../../constants';
import { IMAGE_OPTIONS } from '../share-move.constants';
import './customize.global.css';
import '@updater-components/radio-group';

const DEFAULT_SUBJECT = `I'm moving!`;
const getDefaultMessage = toAddress =>
  `Hi Friends, I'm moving to ${toAddress.city}, ${
    toAddress.state
  }! Come visit sometime soon!`;

const getDefaultItem = toAddress => ({
  kind: ITEM_KINDS.SHARE,
  main_image: IMAGE_OPTIONS.MAP,
  message: getDefaultMessage(toAddress),
  subject: DEFAULT_SUBJECT,
});

class ShareMoveCustomizeController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, {
      updStore,
      imageOptions: {
        map: IMAGE_OPTIONS.MAP,
        graphic: IMAGE_OPTIONS.GRAPHIC,
      },
      message: {
        limit: 144,
      },
    });
  }

  $onInit() {
    const { connect, getState } = this.updStore;
    this.disconnect = connect(mapStateToThis)(this);
    this.updStore.dispatch(actions.step.isTerminalRoute());

    // Not using connect since this is bound to the form
    this.item = this.hasItem
      ? getItemFromState(getState())
      : getDefaultItem(this.toAddress);
  }

  $onDestroy() {
    this.disconnect();
  }

  $onChanges(changes) {
    const { item } = changes;

    if (item && item.currentValue) {
      const { currentValue } = item;

      this.item = {
        main_image: {
          ...currentValue.main_image,
        },
      };
    }
  }

  //create a function to grab main_image type and set item.main_image to submit
  onImgChange(e) {
    this.item.main_image = e.target.value;
  }

  submit(item) {
    const { dispatch } = this.updStore;

    const success = response => {
      dispatch(actions.router.stateGo(STATES.STEP_SHARE_MOVE_PREVIEW));
      dispatch(actions.analytics.track('Saved Moving Announcement'));
    };

    const error = ({ payload }) => {
      dispatch(actions.message.error('There was an error saving your share.'));
      dispatch(
        actions.analytics.track('Error Saving Moving Announcement', {
          Errors: payload.errors,
        })
      );
    };

    dispatch(
      actions.item.create({
        ...item,

        move_id: this.moveId,
      })
    ).then(success, error);
  }
}

export const ShareMoveCustomizeComponent = {
  template,
  controller: ShareMoveCustomizeController,
  bindings: {
    item: '<',
  },
};

function mapStateToThis(state) {
  const { item, move, hasItem } = getCurrentFromState(state);
  const itemStatus = item.status && item.status(state);

  return {
    moveId: move.id(state),
    fromAddress: move.fromAddress(state),
    toAddress: move.toAddress(state),
    cancelSref: getCancelStatus(itemStatus),
    submitting: selectors.pending.match(actions.item.isCreate, state),
    hasItem,
  };
}

function getItemFromState(state) {
  const { item } = getCurrentFromState(state);

  return {
    id: item.id(state),
    main_image: item.mainImage(state),
    message: item.message(state),
    subject: item.subject(state),
  };
}

function getCurrentFromState(state) {
  const { current } = selectors;

  return {
    move: current.move(state),
    item: current.shareMoveItem(state) || {},
    hasItem: current.hasShareMoveItem(state),
  };
}

function getCancelStatus(status) {
  return status === ITEM_STATUSES.STARTED
    ? STATES.STEP_SHARE_MOVE_PREVIEW
    : STATES.DASHBOARD;
}
